<mode-encoding-pill-base
  displayName="Multiple"
  [isValid]="isValidMultiple"
  [isMultiple]="true"
  [isAnalyticCalc]="false"
  [isDiscrete]="false"
  [isContinuous]="false"
  [isDualAxis]="false"
  [isSharedAxis]="false"
  [isDualAxisRelative]="false"
  [contextMenu]="menu"
  caretIcon="icon-system"
  (showMenu)="showContextMenu($event)"
>
  <context-menu>
    <ng-template contextMenuItem let-item (execute)="removeField()">
      <span><span class="context-link-name">Remove</span></span>
    </ng-template>
  </context-menu>
</mode-encoding-pill-base>
